import React from 'react'

// Execution List
const SweepExecutionList = ({itemData,itemKey,data,orderNumber,glsAgent,pageJson,translations,accountCountryList, getCountryTaxonomy}) => {
  //Setting the last order as 'Defined in Group' instead of number  
  if(data.length + 1 === orderNumber){
  orderNumber = 'Defined in Group'
  }
  const item = data.filter(item => item.id === itemData)[0]
  if(item !== undefined){
    return (
      <div className="orderable-sweep-list orderable-sweep-list--sweep">
        <div className="orderable-sweep-list--sweep__ordering-dropdown">
          <div className="gdocs-simple-dropdown-container" style={{width: '98px'}}>
            <span>{orderNumber}</span>
          </div>
        </div>
        <div className="orderable-sweep-list--sweep__sweep-details">
          <label className="orderable-sweep-list--sweep__sweep-details__sweep-name">
          {`${item.sweepId}`}
          <span>
            {'ccrBilateralLimits' in item && item.ccrBilateralLimits.currency !== '' ? `(${item.ccrBilateralLimits.currency})` : ''}
          </span>
          </label>
          <p className="orderable-sweep-list--sweep__sweep-details__sweep-type">
            {`${item.sweepParticipantsAccounts !== undefined ? item.sweepParticipantsAccounts.sweepType.name + ',' : ''}  ${item.sweepParticipantsAccounts !== undefined && 'accountRegion' in  item.sweepParticipantsAccounts ? item.sweepParticipantsAccounts.accountRegion : ''}`}
          </p>
        </div>
        <div className="master-account-details orderable-sweep-account-list">
          <label className="master-account-details__header">{translations(pageJson.master)}</label>
          <p style={{marginBottom: '0px'}} className="master-account-details__account-name">
            {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.masterAccountData.accountNumber + ',' : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.masterAccountData.branchCode + ',' : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.country !== undefined ? accountCountryList !== undefined
                ?getCountryTaxonomy(item.sweepParticipantsAccounts.masterAccountData).country.name+ ',' :item.sweepParticipantsAccounts.masterAccountData.country.name + ',' : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.currency !== undefined ? item.sweepParticipantsAccounts.masterAccountData.currency.name : ''}`}
          </p>
          <p style={{marginBottom: '0px'}} className="master-account-details__others">{item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined ? item.sweepParticipantsAccounts.masterAccountData.accountHolder.name : ''}</p>
          <p style={{marginBottom: '0px'}} className="master-account-details__others">
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.tempRefrenceId !== undefined && item.sweepParticipantsAccounts.masterAccountData.tempRefrenceId !== '' ? `(${item.sweepParticipantsAccounts.masterAccountData.tempRefrenceId})` : ''}
          </p>
        </div>
        <div className="sub-account-details orderable-sweep-account-list">
          <label className="sub-account-details__header">{translations(pageJson.sub)}</label>
          <p style={{marginBottom: '0px'}} className="sub-account-details__account-name">
              {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.subAccountData.accountNumber + ','  : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.subAccountData.branchCode + ','  : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.country !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.subAccountData).country.name+ ',' :item.sweepParticipantsAccounts.subAccountData.country.name + ','  : ''} ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.currency !== undefined ? item.sweepParticipantsAccounts.subAccountData.currency.name : ''}`}
          </p>
          <p style={{marginBottom: '0px'}} className="sub-account-details__others">{item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined ? item.sweepParticipantsAccounts.subAccountData.accountHolder.name : ''}</p>
          <p style={{marginBottom: '0px'}} className="sub-account-details__others">
              {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.tempRefrenceId !== undefined && item.sweepParticipantsAccounts.subAccountData.tempRefrenceId !== '' ? `(${item.sweepParticipantsAccounts.subAccountData.tempRefrenceId})` : ''}
          </p>
        </div>
      </div>
    )
  }else {
    return null;
  }

}

// Group List Item
const SweepGroupLimitList = ({itemData,itemKey,data,intraGroup}) => {
  const item = data.filter(item => item.id === itemData)[0]
  const itemGrp= intraGroup.filter(item => item.sweepInstructionId === itemData)[0]
  if(item !== undefined){
    return (
      <div className="orderable-sweep-list--sweep-group__sweep-instructions">
        <div className="orderable-sweep-list--sweep-group__sweep-instructions__list orderable-sweep-list--sweep-group__sweep-instructions__list--left">
          <label>{`${itemGrp.orderNumber} ${item.sweepId}`}</label>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

// Group list
const SweepExecutionGroupList = ({itemData,itemKey,data,orderNumber,sweepGroup,glsAgent,sweepInstructions,intraGroupOrder,pageJson,translations}) => {
  const item = data.filter(item => item.id === itemData)[0]
  let groupOrderNo= '';
  sweepGroup.forEach((ele,i) => {
    if(ele.id===itemData){
      groupOrderNo = i
    }
  });
  
  if(item !== undefined){
    return (
      <div className="orderable-sweep-list orderable-sweep-list--sweep-group">
        <div className="orderable-sweep-list--sweep-group__ordering-dropdown">
          <div className="gdocs-simple-dropdown-container" style={{width : '98px'}}>
            <span>{orderNumber}</span>
          </div>
        </div>
        <div className="orderable-sweep-list--sweep-group__sweep-details">
          {
            item.sweepId ===undefined ?
            <label className="orderable-sweep-list--sweep-group__sweep-details__sweep-name">{`${pageJson !== undefined ? translations(pageJson.group) : 'Group'} ${item.sweepGroupId} ${'00'}${parseInt(groupOrderNo)+1}`}</label>
            :
            <label className="orderable-sweep-list--sweep-group__sweep-details__sweep-name">{`${pageJson !== undefined ? translations(pageJson.group) : 'Group'} ${item.sweepGroupId} ${'00'}${parseInt(groupOrderNo)+1}`}</label>
          }
          <p className="orderable-sweep-list--sweep-group__sweep-details__sweep-type"> </p>
        </div>
        {
          'sweepInstructions' in item && item.sweepInstructions.length > 0 && item.sweepInstructions.map((item,key) =>
          <SweepGroupLimitList
            itemData={item}
            itemKey={key}
            data={sweepInstructions}
            intraGroup={intraGroupOrder}
          />)
        }
      </div>
    )
  }else {
    return null;
  }
}


//Main
const SweepExecution = ({data,pageJson,translations,translateWordForOption, acc}) => {  
  return (
    <div className="cc-detail-section clearfix">
      <div className="cc-detail-section__heading">{`6. ${translations(pageJson.pageHeading)}`}</div>
     { data.cashConcentration !== undefined && data.cashConcentration.orderOfExecution !== undefined && data.cashConcentration.orderOfExecution !== null && data.cashConcentration.orderOfExecution.length !== 0 ?
      <dl class="ie-detail-section__content__list">
      <dt>{translations(pageJson.sweepOrder)}</dt>
      <dd>{data.cashConcentration.isSweepOrderDefined === true ? 'Yes' :(data.cashConcentration.isSweepOrderDefined === false ? 'No' : 'None')}</dd>
      </dl> : ''}
      {
        data !== undefined && data.cashConcentration !== undefined && data.cashConcentration.isSweepOrderDefined === true ? data.cashConcentration.orderOfExecution.map((item,key) =>(
          <div className="order-of-sweep-execution-section">
            <div className="orderable-sweep-list-wrapper">
              {
                 'sweepId' in item &&
                  <SweepExecutionList
                    itemData={item.sweepId}
                    itemKey={key}
                    data={data.cashConcentration.sweepInstructions}
                    orderNumber={item.orderNumber}
                    glsAgent={data.glsAgent}
                    pageJson={pageJson}
                    translations={translations}
                    translateWordForOption={translateWordForOption}
                  />
              }
              {
                'sweepGroupId' in item  &&
                  <SweepExecutionGroupList
                    itemData={item.sweepGroupId}
                    itemKey={key}
                    data={data.cashConcentration.sweepGroupsLimits}
                    sweepInstructions={data.cashConcentration.sweepInstructions}
                    intraGroupOrder ={item.intraGroupOrder}
                    orderNumber={item.orderNumber}
                    sweepGroup={data.cashConcentration.sweepGroupsLimits}
                    glsAgent={data.glsAgent}
                    pageJson={pageJson}
                    translations={translations}
                    translateWordForOption={translateWordForOption}
                  />
              }
            </div>
          </div>
        )):''
      }
    </div>
  )
}

export default SweepExecution;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepExecution.js